import { Skeleton } from './skeleton';

interface PageLoaderProps {
  hasHeader?: boolean;
  hasStats?: boolean;
  hasChart?: boolean;
  hasTable?: boolean;
}

export const PageLoader = ({ 
  hasHeader = true, 
  hasStats = false, 
  hasChart = false, 
  hasTable = false 
}: PageLoaderProps) => {
  return (
    <div className="space-y-6 p-6">
      {hasHeader && (
        <div className="relative">
          <div className="absolute inset-0 bg-linear-to-r from-purple-500/10 to-blue-500/10 blur-xl" />
          <div className="relative backdrop-blur-xs bg-background/50 rounded-lg p-6 border border-white/10">
            <div className="flex justify-between items-center">
              <div className="space-y-3">
                <Skeleton className="h-10 w-64" />
                <Skeleton className="h-4 w-96" />
              </div>
              <Skeleton className="h-10 w-32" />
            </div>
          </div>
        </div>
      )}

      {hasStats && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="bg-card rounded-lg border p-4">
              <div className="space-y-2">
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-8 w-16" />
                <Skeleton className="h-3 w-24" />
              </div>
            </div>
          ))}
        </div>
      )}

      {hasChart && (
        <div className="bg-card rounded-lg border p-6">
          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <Skeleton className="h-6 w-32" />
              <Skeleton className="h-8 w-24" />
            </div>
            <Skeleton className="h-64 w-full" />
          </div>
        </div>
      )}

      {hasTable && (
        <div className="bg-card rounded-lg border">
          <div className="p-6">
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <Skeleton className="h-6 w-32" />
                <Skeleton className="h-8 w-24" />
              </div>
              <div className="space-y-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div key={i} className="flex justify-between items-center">
                    <div className="flex space-x-3">
                      <Skeleton className="h-10 w-10 rounded-full" />
                      <div className="space-y-1">
                        <Skeleton className="h-4 w-32" />
                        <Skeleton className="h-3 w-24" />
                      </div>
                    </div>
                    <div className="flex space-x-2">
                      <Skeleton className="h-6 w-16" />
                      <Skeleton className="h-8 w-8" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export const DashboardLoader = () => (
  <PageLoader hasHeader hasStats hasChart />
);

export const TablePageLoader = () => (
  <PageLoader hasHeader hasTable />
);

export const SimplePageLoader = () => (
  <PageLoader hasHeader />
);